import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import get from 'lodash/get';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import { isEqual } from 'lodash';
export default {
  name: 'NiotaClassicDevicetypesPacketParserDefault',
  mixins: [formMixin, parserTypesMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      predefinedParser: {
        id: null
      },
      parserConfigInternal: {},
      lastEmittedConfig: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    parseBitsFloatRule() {
      return this.requiredRule.concat([v => parseInt(v) === 16 || parseInt(v) === 32 || parseInt(v) === 64 || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.bitValidationText')]);
    },
    parserTargetIsUniqueRule() {
      return this.requiredRule.concat([v => /^[a-zA-Z0-9_\\.]+$/.exec(v) !== null || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variableNameRule'), v => get(this.parserConfigInternal, 'parseElements', []).filter(e => e.target === v).length === 1 || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariableUniqueError')]);
    }
  },
  watch: {
    parserConfigInternal: {
      handler: function (newVal) {
        if (isEqual(cloneDeep(newVal), cloneDeep(this.lastEmittedConfig))) {
          return;
        }
        this.emitChanges();
      },
      deep: true
    },
    parserConfig: {
      handler: function (val) {
        this.parserConfigInternal = cloneDeep(val);
      },
      immediate: true
    }
  },
  created() {
    this.handleParserConfigChanged();
  },
  methods: {
    emitChanges() {
      this.lastEmittedConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', this.parserConfigInternal);
    },
    handleParserConfigChanged() {
      if (!this.parserConfigInternal.parseElements) {
        this.parserConfigInternal.parseElements = [];
      }
      if (!this.parserConfigInternal.calculateElements) {
        this.parserConfigInternal.calculateElements = [];
      }
      const newPredefinedId = get(this.parserConfigInternal, 'custom') || null;
      if (get(this.predefinedParser, 'id') !== newPredefinedId) {
        this.predefinedParser = {
          id: get(this.parserConfigInternal, 'custom') || null
        };
        this.predefinedParserSelected();
      }
      this.emitChanges();
    },
    predefinedParserSelected() {
      this.parserConfigInternal.custom = this.predefinedParser.id;
      if (this.parserConfigInternal.custom) {
        const foundParser = this.predefinedParserVars.find(p => p.id === this.parserConfigInternal.custom) || {};
        // preserve existing variables in the config, overwrite definitions of the predefined parser
        this.parserConfigInternal.variables = {
          ...(foundParser.fields || {}),
          ...(this.parserConfigInternal.variables || {})
        };
      } else {
        delete this.parserConfigInternal.custom;
      }
      this.emitChanges();
    },
    addParseBitRange(index) {
      const clonedConfig = cloneDeep(this.parserConfigInternal);
      if (!clonedConfig.parseElements) {
        clonedConfig.parseElements = [];
      }

      // TODO: add after index!
      clonedConfig.parseElements.splice(index + 1, 0, {
        bits: 8,
        type: 'int',
        target: ''
      });
      this.parserConfigInternal = clonedConfig;
    },
    removeParseBitRange(index) {
      pullAt(this.parserConfigInternal.parseElements, [index]);
      this.emitChanges();
    },
    bitRange(parserElementIndex) {
      let bits = 0;
      for (let i = 0; i < parserElementIndex; i++) {
        bits += parseInt(this.parserConfigInternal.parseElements[i].bits);
      }
      return `${bits}-${bits + parseInt(this.parserConfigInternal.parseElements[parserElementIndex].bits) - 1}`;
    },
    onCalculationConfigUpdated(calculateElements) {
      this.parserConfigInternal.calculateElements = calculateElements;
      this.emitChanges();
    }
  }
};